export const dayFill = [
    {
      value: 7,
      label: '7N',
      step: '1',
    },
    {
      value: 30,
      label: '30N',
      step: '5',
    },
    {
      value: 90,
      label: '90N',
      step: '10',
    },
    {
      value: 180,
      label: '180N',
      step: '30',
    },
  ];
  